export const CACHE_KEY_LIST_CLIENT_REGISTERS = 'clientRegisters';
export const CACHE_KEY_CLIENT_REGISTERS = 'clientRegisters-one';
export const CACHE_KEY_CLIENT_REGISTERS_MAIN = 'clientRegisters-main';
export const CACHE_KEY_CLIENT_REGISTERS_PERIOD = 'clientRegisters-period';
export const CACHE_KEY_CLIENT_KITCHEN_REGISTERS = 'clientRegistersKitchen-one';
export const CACHE_KEY_CLIENT_POOL_REGISTERS = 'clientRegistersPool-one';
export const CACHE_KEY_CLIENT_LEGIONELLA_REGISTERS = 'clientRegistersLegionella-one';
export const CACHE_KEY_CLIENT_OTHERS_REGISTERS = 'clientRegistersOthers-one';
export const ROUTE_PATH_CLIENT_REGISTERS = '/client-registers';
export const ROUTE_PATH_CLIENT_POOL_REGISTERS = '/client-registers/pool';
export const ROUTE_PATH_CLIENT_KITCHEN_REGISTERS = '/client-registers/kitchen';
export const ROUTE_PATH_CLIENT_LEGIONELLA_REGISTERS = '/client-registers/legionella';
export const ROUTE_PATH_CLIENT_OTHERS_REGISTERS = '/client-registers/others';
export const TRANSLATION_PREFIX_CLIENT_REGISTERS = 'clientRegisters';
export const CACHE_KEY_LIST_CLIENT_KITCHEN_PENDING_REGISTERS = 'clientKitchenPendingRegisters';
export const CACHE_KEY_LIST_CLIENT_KITCHEN_CLOSED_REGISTERS = 'clientKitchenClosedRegisters';
export const CACHE_KEY_LIST_CLIENT_KITCHEN_REGISTERS = 'clientKitchenRegisters';
export const CACHE_KEY_LIST_CLIENT_PENDING_REGISTERS = 'clientPendingRegisters';
export const CACHE_KEY_LIST_CLIENT_CLOSED_REGISTERS = 'clientClosedRegisters';
export const CACHE_KEY_LIST_CLIENT_POOL_PENDING_REGISTERS = 'clientPoolPendingRegisters';
export const CACHE_KEY_LIST_CLIENT_POOL_CLOSED_REGISTERS = 'clientPoolClosedRegisters';
export const CACHE_KEY_LIST_CLIENT_POOl_REGISTERS = 'clientPoolRegisters';
export const CACHE_KEY_LIST_CLIENT_LEGIONELLA_PENDING_REGISTERS = 'clientLegionellaPendingRegisters';
export const CACHE_KEY_LIST_CLIENT_LEGIONELLA_CLOSED_REGISTERS = 'clientLegionellaClosedRegisters';
export const CACHE_KEY_LIST_CLIENT_LEGIONELLA_REGISTERS = 'clientLegionellaRegisters';
export const CACHE_KEY_LIST_CLIENT_OTHERS_PENDING_REGISTERS = 'clientOthersPendingRegisters';
export const CACHE_KEY_LIST_CLIENT_OTHERS_CLOSED_REGISTERS = 'clientOthersClosedRegisters';
export const CACHE_KEY_LIST_CLIENT_OTHERS_REGISTERS = 'clientOthersRegisters';
export const CACHE_KEY_CLIENT_REGISTER_FREQ_COMPLETION = 'clientRegisterFreqCompletion';
export const CACHE_KEY_CLIENT_REGISTER_CHECK_IS_PENDING = 'clientRegisterCheckIsPending';
export const CACHE_KEY_CLIENT_REGISTER_CLOSED_PERIODS = 'clientRegisterClosedPeriods';

export const AREA_TYPE_IDS = {
  KITCHEN: process.env.REACT_APP_KITCHEN_AREA_TYPE_ID || '6222de718392273acda01d10',
  LEGIONELLA: process.env.REACT_APP_LEGIONELLA_AREA_TYPE_ID || '6222de90839227088fa01d14',
  OTHERS: process.env.REACT_APP_OTHERS_AREA_TYPE_ID || '6222de9983922758baa01d16',
  POOL: process.env.REACT_APP_POOL_AREA_TYPE_ID || '6222de648392275e46a01d0e'
};
